import React from "react";
import { useTranslation } from "react-i18next";
import PrivacyPolicyFr from "./PrivacyPolicyFR";
import PrivacyPolicyEn from "./PrivacyPolicyEN";

const PrivacyPolicy = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div className="container mx-auto px-4 py-8 text-onWhite">
      {lang === "fr" ? (
        <PrivacyPolicyFr />
      ) : lang === "en" ? (
        <PrivacyPolicyEn />
      ) : (
        <PrivacyPolicyFr />
      )}
    </div>
  );
};

export default PrivacyPolicy;
